import noUiSlider from 'nouislider'
import 'nouislider/distribute/nouislider.css'
import Inputmask from 'inputmask'

import './range-slider.scss'
import createList from './create-list'

const triggerJqueryChange = input => {
  if ('jQuery' in window) {
    window.jQuery(input).trigger('change')
  }
}

const rangeSlider = container => {
  createList(container)

  const pricesliders = container.querySelectorAll('[data-filter-range-price]')
  const yearSliders = container.querySelectorAll('[data-filter-range-year]')
  const priceInputs = container.querySelectorAll('[data-input-price]')
  const activeYears = container.querySelectorAll('[data-year-active]')
  const yearItems = container.querySelectorAll('[data-year]')
  const yearSelects = container.querySelectorAll('[data-select-year]')

  pricesliders.forEach(priceSlider => {
    if ('initialized' in priceSlider.dataset) return
    priceSlider.dataset.initialized = ''
    const priceMin = container.querySelector('[data-price-min]')
    const priceMax = container.querySelector('[data-price-max]')

    const im = new Inputmask('decimal', {
      groupSeparator: "'",
      autoUnmask: true,
    })
    priceMin.setAttribute('type', 'text')
    priceMax.setAttribute('type', 'text')

    im.mask(priceMin)
    im.mask(priceMax)

    // const stepContainer = container.querySelector('[data-price-step]')
    // let step

    if (!priceMin || !priceMax) return

    if (+priceMax.dataset.priceMax === 0) {
      priceMax.dataset.priceMax = 500000000
    }
    // if (
    //   !stepContainer ||
    //   !+stepContainer.dataset.priceStep ||
    //   +stepContainer.dataset.priceStep < 1
    // ) {
    //   step = 500000
    // } else {
    //   step = +stepContainer.dataset.priceStep
    // }

    noUiSlider.create(priceSlider, {
      start: [
        priceMin.value || +priceMin.dataset.priceMin,
        priceMax.value || +priceMax.dataset.priceMax,
      ],
      connect: true,
      range: {
        min: [+priceMin.dataset.priceMin],
        max: [+priceMax.dataset.priceMax],
      },
      // step,
    })

    priceSlider.noUiSlider.on('update', value => {
      const [min, max] = value

      priceInputs.forEach(price => {
        if (price.dataset.inputPrice === 'min') {
          price.value = Math.round(min)
        }

        if (price.dataset.inputPrice === 'max') {
          price.value = Math.round(max)
        }
      })
    })

    priceSlider.noUiSlider.on('set', () => {
      priceInputs.forEach(price => {
        if (price.dataset.inputPrice === 'min') {
          triggerJqueryChange(price)
        }

        if (price.dataset.inputPrice === 'max') {
          triggerJqueryChange(price)
        }
      })
    })

    priceInputs.forEach(price => {
      price.addEventListener('change', evt => {
        if (evt.target.dataset.inputPrice === 'min') {
          priceSlider.noUiSlider.setHandle(0, evt.target.value, false) // do not trigger 'set' event
        }

        if (evt.target.dataset.inputPrice === 'max') {
          priceSlider.noUiSlider.setHandle(1, evt.target.value, false) // do not trigger 'set' event
        }
      })
    })
  })

  yearSliders.forEach(yearSlider => {
    const minYear = container.querySelector('[data-year-min]')
    const maxYear = container.querySelector('[data-year-max]')
    const selectMin = container.querySelector('[data-select-year="min"]')
    const selectMax = container.querySelector('[data-select-year="max"]')

    if (!minYear || !maxYear) return

    if ('initialized' in yearSlider.dataset) return
    yearSlider.dataset.initialized = ''

    noUiSlider.create(yearSlider, {
      start: [
        selectMin.value || +minYear.dataset.yearMin,
        selectMax.value || +maxYear.dataset.yearMax,
      ],
      connect: true,
      range: {
        min: [+minYear.dataset.yearMin],
        max: [+maxYear.dataset.yearMax],
      },
    })

    yearSlider.noUiSlider.on('update', value => {
      const [min, max] = value

      activeYears.forEach(year => {
        if (year.dataset.yearActive === 'min') {
          year.textContent = Math.round(min)
        }

        if (year.dataset.yearActive === 'max') {
          year.textContent = Math.round(max)
        }
      })

      yearSelects.forEach(item => {
        if (item.dataset.selectYear === 'min') {
          item.value = Math.round(min)
        }

        if (item.dataset.selectYear === 'max') {
          item.value = Math.round(max)
        }
      })
    })

    yearSlider.noUiSlider.on('set', () => {
      yearSelects.forEach(item => {
        if (item.dataset.selectYear === 'min') {
          triggerJqueryChange(item)
        }

        if (item.dataset.selectYear === 'max') {
          triggerJqueryChange(item)
        }
      })
    })

    yearItems.forEach(year => {
      year.addEventListener('click', e => {
        if (e.target.dataset.year === 'min') {
          yearSlider.noUiSlider.setHandle(0, e.target.textContent, true)
        }

        if (e.target.dataset.year === 'max') {
          yearSlider.noUiSlider.setHandle(1, e.target.textContent, true)
        }
      })
    })

    yearSelects.forEach(year => {
      year.addEventListener('change', e => {
        if (e.target.dataset.selectYear === 'min') {
          yearSlider.noUiSlider.setHandle(0, e.target.value, false) // do not trigger 'set' event
        }

        if (e.target.dataset.selectYear === 'max') {
          yearSlider.noUiSlider.setHandle(1, e.target.value, false) // do not trigger 'set' event
        }
      })
    })
  })
}

export default rangeSlider

if ('jQuery' in window) {
  jQuery(document).ajaxComplete(() => {
    jQuery('[data-year-active="min"]').text(
      jQuery('[data-select-year="min"]').attr('value')
    )
    jQuery('[data-year-active="max"]').text(
      jQuery('[data-select-year="max"]').attr('value')
    )
    rangeSlider(document.body)
  })
}
